/** 滞留と判定する営業日数（issue #29 の確定仕様）。 */
export const STUCK_THRESHOLD_BUSINESS_DAYS = 5;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * 2 つの日時の間の営業日数（土日を除く）。
 *
 * 祝日は考慮しない。祝日カレンダーは組織・国ごとに変わり正本を持てないため、
 * 「滞留の目安」の用途では土日除外までで十分と判断した。必要になったら
 * 休日マスタを外部から受け取る形に拡張する。
 */
export function businessDaysBetween(from: Date, to: Date): number {
  const start = startOfDay(from);
  const end = startOfDay(to);
  if (end <= start) return 0;

  let days = 0;
  for (let cursor = start + MS_PER_DAY; cursor <= end; cursor += MS_PER_DAY) {
    if (!isWeekend(new Date(cursor))) days += 1;
  }
  return days;
}

/** 現在ステップが閾値を超えて動いていないか。 */
export function isStuck(since: Date | null, now: Date = new Date()): boolean {
  if (since === null) return false;
  return businessDaysBetween(since, now) > STUCK_THRESHOLD_BUSINESS_DAYS;
}

function startOfDay(date: Date): number {
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

function isWeekend(date: Date): boolean {
  const day = date.getUTCDay();
  return day === 0 || day === 6;
}
